<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-3 text-left">
                <h3>Admin Home</h3>
              </div>
            </div>
            <div class="row" style="margin-bottom:10px;">
              <div v-for="stat in store.state.stats" class="col-xs-12 col-sm-2 bubble" :key="stat.title">
                <h5>{{stat.title}}</h5>
                <h3>{{stat.value}}</h3>
              </div>
            </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminHomeStore from './AdminHomeStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminHome',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminHomeStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.store.reset()
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      this.store.getStats(data => {
      },err => {
      });
    },(err) => {
      this.$toasted.show(err, { type: "error", duration: 2500 });
      this.nav.goAdminLogin(this)
    })
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bubble{
  height: 100px;
  background: white;
  border-radius: 20px;
  margin-left: 20px;
  padding-top: 10px;
  margin-top:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminHome.vue